var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup26(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6444 51.3143C11.5126 51.3143 0 39.796 0 25.6572C0 11.5184 11.5126 0 25.6444 0C39.7762 0 51.2888 11.5184 51.2888 25.6572C51.2888 39.796 39.7762 51.3143 25.6444 51.3143ZM25.6444 1.4686C12.3185 1.4686 1.43908 12.3247 1.43908 25.686C1.43908 39.0473 12.2897 49.9033 25.6444 49.9033C38.9991 49.9033 49.8497 39.0473 49.8497 25.686C49.8497 12.3247 38.9991 1.4686 25.6444 1.4686Z",
    fill: "#209BB7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5152 27.5865L1.32397 19.0917L1.78448 17.7383L25.443 25.398L19.0247 1.43977L20.4062 1.06543L27.5152 27.5865Z",
    fill: "#209BB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup26);
export default __webpack_public_path__ + "static/media/Group26.669ca6c94a0d8558fd0201208d627a5b.svg";
export { ForwardRef as ReactComponent };